import React from 'react'

function onlineregistration() {
  return (
    <div>
    <h1> Onlineregistration</h1>
    </div>
  )
}

export default onlineregistration
